module.exports = __webpack_public_path__ + "img/ic_140_achievement_siegesserie.b10af940.svg";